import { ArrowChevronDownIcon } from '@tableau/icons/ArrowChevronDownIcon';
import { ArrowChevronRightIcon } from '@tableau/icons/ArrowChevronRightIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { expandedRowFocus } from './DataConnectMultiPoolTableEntryPool';

export type ExpandPoolButtonProps = Readonly<{
  isExpanded: boolean;
  setExpanded: (expand: boolean) => void;
  isDisabled: boolean;
}>;

export function ExpandPoolButton(props: ExpandPoolButtonProps) {
  const focusHighlight = props.isExpanded ? expandedRowFocus : '';
  return (
    <td className={`tb-data-grid-separator-row ${focusHighlight}`} style={{width: 37, textAlign: 'right'}}>
      <span className={'tb-data-grid-icon tb-padded-left-large'} data-tb-test-id={'pool-expand-icon'}>
        <ButtonWidget
          buttonType={ButtonType.IconOutline}
          testId={'expand-pool-button'}
          onClick={() => props.setExpanded(!props.isExpanded)}
          disabled={props.isDisabled}
        >
          {props.isExpanded ?
            <ArrowChevronDownIcon size={14} alt={Messages.collapse()} />
            :
            <ArrowChevronRightIcon size={14} alt={Messages.expand()} />
          }
        </ButtonWidget>
      </span>
    </td>
  );
}
